<template>
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title">Duplicate Project</p>
    </header>
    <section class="modal-card-body">
      <b-field><b-input v-model="form.name" placeholder="Project Name" /></b-field>
      <b-field><b-input v-model="form.mainDomain" placeholder="Main Domain" /></b-field>
    </section>
    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.close()">Close</button>
      <button class="button is-primary" @click="duplicate">Duplicate</button>
    </footer>
  </div>
</template>

<script>
import http from '@/lib/utils/http'
import { error, success } from '@/lib/utils/toast'

export default {
  name: 'duplicate-form',
  props: ['projectId'],
  data() {
    return {
      form: {
        name: '',
        mainDomain: '',
      },
    }
  },
  methods: {
    duplicate() {
      http
        .post(`projects/${this.projectId}/duplicate`, this.form)
        .then(resp => {
          this.$router.push(`projects/${resp.data.id}/edit`)
          this.$toast.open(success())
        })
        .catch(() => {
          this.$toast.open(error())
        })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Projects/List/DuplicateForm.vue